import React from 'react';
import { Row, Col, Card, Statistic, Skeleton } from 'antd';
import { formatCurrency } from '../../utils/formatters';
import { COLOR_SUCCESS, COLOR_ERROR } from '../../utils/colors';

const PaymentStatsCards = ({ loading, stats }) => (
  <Row gutter={[16, 16]}>
    <Col span={12}>
      <Card style={{ borderTop: `3px solid ${COLOR_SUCCESS}` }}>
        <Skeleton loading={loading} active paragraph={{ rows: 2 }}>
          <Statistic title="Total Income" value={stats.income} formatter={(v) => formatCurrency(v)} valueStyle={{ color: COLOR_SUCCESS }} />
          <Statistic title="Income VAT" value={stats.incomeVAT} formatter={(v) => formatCurrency(v)} valueStyle={{ fontSize: '14px', color: '#666' }} style={{ marginTop: '8px' }} />
        </Skeleton>
      </Card>
    </Col>
    <Col span={12}>
      <Card style={{ borderTop: `3px solid ${COLOR_ERROR}` }}>
        <Skeleton loading={loading} active paragraph={{ rows: 2 }}>
          <Statistic title="Total Expenses" value={stats.expense} formatter={(v) => formatCurrency(v)} valueStyle={{ color: COLOR_ERROR }} />
          <Statistic title="Expense VAT" value={stats.expenseVAT} formatter={(v) => formatCurrency(v)} valueStyle={{ fontSize: '14px', color: '#666' }} style={{ marginTop: '8px' }} />
        </Skeleton>
      </Card>
    </Col>
  </Row>
);

export default PaymentStatsCards;
